module.exports = __webpack_public_path__ + "img/img18.46bd599c.svg";